export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_CREATE_LOADING = 'USER_CREATE_LOADING';
export const USER_CREATE_FAILED = 'USER_CREATE_FAILED';
export const USER_CREATE_LOAD = 'USER_CREATE_LOAD';
export const USER_SHOW_MODAL = 'USER_SHOW_MODAL';
export const USER_HIDE_MODAL = 'USER_HIDE_MODAL';
